import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchOrganism } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const OrganismDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
}) => {
  const organismName = getValues().organism_name;
  const selectedOrganism = watch("organism_id");

  const {
    data: Organisms,
    isLoading,
    error,
  } = useQuery(["Organism"], () => fetchOrganism(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Lab Department</div>;

  const modifiedData = Organisms?.data?.data?.map((ele) => ({
    ...ele,
    organism_id: ele.id,
  }));

  const options =
    modifiedData?.map((organism) => ({
      value: organism.organism_id,
      label: organism.organism_name,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selectedOrganism || organismName
  );
  return (
    <Controller
      name="organism_id"
      control={control}
      rules={{ required: "Organism is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Organism"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("organism_id", value);
          }}
          className={`react-select-container ${
            errors.organism_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default OrganismDropdown;
